// internal imports
import { useAppContext } from "../../layout/layout";
import { Wrapper, Link } from "./link-button.component.styles";

const LinkButton = ({ herf, children }) => {
  const { isDarkTheme } = useAppContext();
  return (
    <Wrapper className={`${isDarkTheme ? "dark" : "light"}`}>
      <Link href={herf} target="_blank" download>
        {children}
      </Link>
    </Wrapper>
  );
};
export default LinkButton;
